import React from 'react'
import { withTranslation } from 'react-i18next'
import { GoogleMap, LoadScript } from '@react-google-maps/api'
import TagMultiSelect from '../TagMultiSelect'
import IpRangeInput from '../IpRangeInput'

const GOOGLE_MAP_API_KEY = 'AIzaSyBJ7-WmV3fyhS64yd2XTzZQebwtUCrf2nk'
const MAP_CENTER = { lat: 9.0820, lng: 8.6753 }
const MAP_STYLE = { width: '100%', height: '300px', borderRadius: '12px' }

const INTEREST_OPTIONS = ['Fuel', 'Grocery', 'Drivers', 'Mobility', 'Rewards Lovers', 'Automotive', 'Fuel & Energy', 'Commuting', 'Retail', 'Dining', 'Entertainment', 'Travel']
const LOCATION_OPTIONS = ['Lagos', 'Ibadan', 'Kano State', 'Abuja', 'Port Harcourt', 'Accra', 'Kumasi', 'Takoradi', 'Tamale']

export default withTranslation()(function TargetingStep({ t, form, updateField }) {
  return (
    <div className="flex flex-col gap-6 max-w-[640px]">
      <h2 className="text-xl font-semibold text-dark-blue">{t('rewardAds.createFlow.targeting.title')}</h2>

      <TagMultiSelect
        label={t('rewardAds.createFlow.targeting.interest.label')}
        placeholder={t('rewardAds.createFlow.targeting.interest.placeholder')}
        options={INTEREST_OPTIONS}
        values={form.interests}
        onChange={(values) => updateField('interests', values)}
      />

      <TagMultiSelect
        label={t('rewardAds.createFlow.targeting.location.label')}
        placeholder={t('rewardAds.createFlow.targeting.location.placeholder')}
        options={LOCATION_OPTIONS}
        values={form.locations}
        onChange={(values) => updateField('locations', values)}
      />

      <IpRangeInput
        label={t('rewardAds.createFlow.targeting.ip_targeting.label')}
        placeholder={t('rewardAds.createFlow.targeting.ip_targeting.placeholder')}
        values={form.ipRanges}
        onChange={(values) => updateField('ipRanges', values)}
      />

      <div className="flex flex-col gap-2">
        <label className="text-sm font-medium text-dark-blue">{t('rewardAds.createFlow.targeting.map_label')}</label>
        <LoadScript googleMapsApiKey={GOOGLE_MAP_API_KEY}>
          <GoogleMap mapContainerStyle={MAP_STYLE} center={MAP_CENTER} zoom={6} options={{ disableDefaultUI: true }} />
        </LoadScript>
      </div>
    </div>
  )
})
